import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../css/SignIn.css';

const SignIn = ({ setIsLoggedIn }) => {
    const navigate = useNavigate();
    const [usernameOrEmail, setUsernameOrEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                username_or_email: usernameOrEmail,
                password: password
            }),
        };

        try {
            const response = await fetch("https://api.affordablecustomehr.com/psychology-ai-note-generator/api/login", requestOptions);
            const result = await response.json();

            if (response.ok) {
                setIsLoggedIn(true);
                navigate('/note-form');
            } else {
                setError(result.error || "Invalid login credentials");
            }
        } catch (error) {
            console.error("Login error:", error);
            setError("An error occurred. Please try again.");
        }
    };

    return (
        <div className="sign-in flex flex-col items-center justify-center h-screen bg-gray-100 px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">Sign In</h2>
            <form onSubmit={handleLogin} className="login-form w-full max-w-md bg-white p-6 rounded-lg shadow-md space-y-4">
                <div className="form-group">
                    <label htmlFor="usernameOrEmail">Username or Email</label>
                    <input
                        type="text"
                        id="usernameOrEmail"
                        value={usernameOrEmail}
                        onChange={(e) => setUsernameOrEmail(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        autoComplete="off" // Turn off autocomplete to prevent autofill
                    />
                </div>
                {error && <p className="error-message">{error}</p>}
                <button type="submit" className="login-button">Log In</button>
            </form>
            <p className="register-link text-center text-gray-700 mt-4">
                Don't have an account? <Link to="/register" className="text-blue-500 hover:underline">Register here</Link>
            </p>
        </div>
    );
};

export default SignIn;
